import React from 'react';
import { Box } from '@tapresearch/ui/components';
import { Skeleton } from '@chakra-ui/react';
import { OpacityTransitionBox } from '../../../shared/OpacityTransitionBox';
export function MultipleSkeletonLoader(param) {
    var numItems = param.numItems;
    return /*#__PURE__*/ React.createElement(OpacityTransitionBox, {
        padding: "6",
        "data-testid": "multiple-skeleton-loader"
    }, Array(numItems).fill(0).map(function(_, i) {
        return /*#__PURE__*/ React.createElement(Box, {
            mb: "6",
            key: "skeleton-".concat(i)
        }, /*#__PURE__*/ React.createElement(Skeleton, {
            h: "80px"
        }));
    }));
}
